import ProductCreationInfoService from '../../services/ProductCreationInfoService';
import productCreationInfoUseCase from './productCreationInfoUseCase';

const productCreationInfoFactory = productCreationInfoUseCase({
  ProductCreationInfoService: ProductCreationInfoService(),
});

export default productCreationInfoFactory;
